"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyValueTypes = void 0;
var PropertyValueTypes;
(function (PropertyValueTypes) {
    PropertyValueTypes["STRING"] = "string";
    PropertyValueTypes["DATETIME"] = "datetime";
    PropertyValueTypes["INT"] = "int";
    PropertyValueTypes["FLOAT"] = "float";
    PropertyValueTypes["BOOL"] = "boolean";
    PropertyValueTypes["RELATION"] = "relation";
    PropertyValueTypes["JSON"] = "json";
})(PropertyValueTypes = exports.PropertyValueTypes || (exports.PropertyValueTypes = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvcHVibGljL2ludGVyZmFjZXMvUHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsSUFBWSxrQkFRWDtBQVJELFdBQVksa0JBQWtCO0lBQzVCLHVDQUFpQixDQUFBO0lBQ2pCLDJDQUFxQixDQUFBO0lBQ3JCLGlDQUFXLENBQUE7SUFDWCxxQ0FBZSxDQUFBO0lBQ2Ysc0NBQWdCLENBQUE7SUFDaEIsMkNBQXFCLENBQUE7SUFDckIsbUNBQWEsQ0FBQTtBQUNmLENBQUMsRUFSVyxrQkFBa0IsR0FBbEIsMEJBQWtCLEtBQWxCLDBCQUFrQixRQVE3QiJ9